module.exports = __webpack_public_path__ + "img/icon_tu.b9e55db1.png";